const Button = ({ children, className, color = "silver", ...rest }) => {
  return (
    <button className={`sk-button sk-button--${color} ${className}`} {...rest}>
      {children}
    </button>
  );
};

export default Button;
